import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierRegistrationService,
  CarrierRegistrationModel,
  CarrierRegistrationTypeRequest,
  CarrierCompanyRequest,
  VehicleCargoRequest,
  VehicleEditPhotosModel,
  DocumentTypeCarrierRegistration,
  CarrierRegistrationTwicRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsVoidType, RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierRegistrationApiService {
  constructor(private apiService: CarrierRegistrationService) {}

  public cancelRegistration(requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierRegistrationCancel(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCarrierRegistrationData(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationGet(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setBusinessType(body: CarrierRegistrationTypeRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationSetBusinessType(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setCompany(body: CarrierCompanyRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationSetCompany(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setVehicleCargo(body: VehicleCargoRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationSetVehicleCargo(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setVehiclePhotos(vehicleEditPhotosModel: VehicleEditPhotosModel, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationSetVehiclePhotos(vehicleEditPhotosModel, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public skipIacssp(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationSkipIacssp(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public skipTwic(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationSkipTwic(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public verifyDocumentMultipleFiles(documentType: DocumentTypeCarrierRegistration, requestBody: string[], requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationVerifyDocumentMultipleFiles(documentType, requestBody, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public verifyTwic(body: CarrierRegistrationTwicRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationModel> {
    return this.apiService.carrierRegistrationVerifyTwic(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
